import React, { useEffect, useState } from 'react'
import '../v2/InputTextForm/index.scss'
import { get, useFormContext, useFormState } from 'react-hook-form'
import clsx from 'clsx'
import FieldErrorSectionForm from '@App/kit/fields/FieldErrorSectionForm'
import { doesFieldHaveFocus } from '@App/common/utils'
import { FormFieldProps } from '@App/forms/common/form-field'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'

const InputTextForm = (props: FormFieldProps) => {
    const formState = useFormState()
    const { register, watch } = useFormContext()
    const [hasFocus, setFocus] = useState(false)

    const {
        name,
        label,
        registerOptions,
        assistiveText,
        mainColor = true,
        assistiveTextFunction,
        assistiveTextVisibility,
        inputType,
        tooltipType,
        tooltipPopupText,
    } = props

    useEffect(() => {
        setFocus(doesFieldHaveFocus(name))
    }, [])

    const setFocusIfNotDisabled = (isFocused: boolean) => {
        if ((!!registerOptions && !registerOptions.disabled) || !registerOptions) {
            setFocus(isFocused)
        }
    }
    const disabled = !!registerOptions && registerOptions.disabled
    const fieldValue = watch(name)
    const error = get(formState.errors, name)
    const outerDivClassNames = clsx(
        mainColor ? 'main-color-set' : 'second-color-set',
        'input-text-form-component',
        hasFocus && 'focused',
        error && 'error',
        disabled && 'disabled',
        !!fieldValue && 'filled'
    )

    const registerResult = register(name, registerOptions)

    const displayAssistiveText = assistiveText ? assistiveText : assistiveTextFunction ? assistiveTextFunction() : ''

    return (
        <div className={outerDivClassNames}>
            {tooltipType && tooltipPopupText && <CustomToolTip type={tooltipType} info={tooltipPopupText} />}
            <label className="input-text-form-label" htmlFor={name}>
                {label}
            </label>
            <input
                {...registerResult}
                onFocus={() => setFocusIfNotDisabled(true)}
                onBlur={(e) => registerResult.onBlur(e).then(() => setFocusIfNotDisabled(false))}
                id={name}
                type={inputType}
            />
            <FieldErrorSectionForm
                name={name}
                assistiveText={displayAssistiveText}
                visibility={assistiveTextVisibility}
                required={!!registerOptions && !!registerOptions.required}
            />
        </div>
    )
}

export default InputTextForm
